export const INPUT_TEXT = 'input-text';
export const INPUT_PASSWORD = 'input-password';
export const BUTTON_PRIMARY = 'button-primary';
export const BUTTON_SECONDARY = 'button-secondary';
export const BUTTON_TERTIARY = 'button-link';
export const INPUT_FIELD_ERROR = 'form-item-input-field-error';
export const INPUT_CHECKBOX = 'input-checkbox';
export const INPUT_CHECKBOX_GROUP = 'input-checkbox-group';
export const INPUT_RADIO_GROUP = 'input-radio-group';
export const INPUT_RADIO_LABEL = 'input-radio-label';
export const INPUT_RADIO = 'input-radio';
export const INPUT_TEXT_AREA = 'input-text-area';
export const SELECT = 'select-element';
export const SELECT_OPTION = 'select-option';
export const FORM_ITEM = 'form-item';
